import { useState, useCallback } from 'react';

function useProgressModal() {
  const [progressState, setProgressState] = useState({
    show: false,
    title: '',
    progress: 0,
    current: 0,
    total: 1, // Iniciar com 1 para evitar divisão por zero
    errors: 0,
    onCancel: null,
  });

  const showProgressModal = useCallback((title, total, onCancel = null) => {
    setProgressState({
      show: true,
      title,
      progress: 0,
      current: 0,
      total: Math.max(total, 1), // Garantir que seja pelo menos 1
      errors: 0,
      onCancel,
    });
  }, []);

  const updateProgress = useCallback((current, errors = 0) => {
    setProgressState(prev => {
      const safeTotal = Math.max(prev.total, 1);
      const safeCurrent = Math.min(current, safeTotal);
      return {
        ...prev,
        progress: safeCurrent / safeTotal,
        current: safeCurrent,
        errors: prev.errors + errors,
      };
    });
  }, []);

  const hideProgressModal = useCallback(() => {
    setProgressState(prev => ({ ...prev, show: false }));
  }, []);

  return {
    progressState,
    showProgressModal,
    updateProgress,
    hideProgressModal,
  };
}

export default useProgressModal;
